import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f7ae1aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 11,
  class: "flex justify-start"
}
const _hoisted_2 = {
  key: 13,
  class: "flex justify-start"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs font-medium px-3 py-1 rounded flex items-center justify-center bg-gray-200 text-black"
}
const _hoisted_4 = {
  key: 14,
  class: "flex justify-start"
}
const _hoisted_5 = {
  key: 0,
  class: "text-xs font-medium px-3 py-1 rounded flex items-center justify-center bg-gray-200 text-black"
}
const _hoisted_6 = {
  key: 0,
  class: "w-5 h-5 flex items-center justify-center rounded-full bg-green-500 p-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-white" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "w-5 h-5 flex items-center justify-center rounded-full bg-red-500 p-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-white" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_take_table_row_actions = _resolveComponent("take-table-row-actions")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_cargo_status = _resolveComponent("cargo-status")!

  return (_ctx.column.key === 'actions')
    ? (_openBlock(), _createBlock(_component_take_table_row_actions, {
        key: 0,
        row: _ctx.row,
        "is-can-assign": _ctx.isCanAssign,
        "is-can-change-date": _ctx.isCanChangeDate,
        "is-can-set-wait-list": _ctx.isCanSetWaitList,
        onResend: _ctx.emitResend,
        onAssignOrder: _ctx.emitAssignOrder,
        onChangeDate: _ctx.emitChangeDate,
        onWaitList: _ctx.emitWaitList,
        onShortcoming: _ctx.emitShortcoming,
        onPayment: _ctx.emitPayment
      }, null, 8, ["row", "is-can-assign", "is-can-change-date", "is-can-set-wait-list", "onResend", "onAssignOrder", "onChangeDate", "onWaitList", "onShortcoming", "onPayment"]))
    : (_ctx.column.key === 'orderNumber' && _ctx.row.orderId && _ctx.row.orderNumber)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "text-blue-500",
          to: `/order/${_ctx.row.orderId}`,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row.orderNumber), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.column.key === 'problems')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.row.problems, (pb, i) => {
            return (_openBlock(), _createBlock(_component_cheap, {
              key: `pb-${i}`,
              class: "CheapItem w-max small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pb), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : (_ctx.column.key === 'takeDate')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(_ctx.row.takeDate)), 1)
            ], 64))
          : (_ctx.column.key === 'createdAt')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
              ], 64))
            : (_ctx.column.key === 'city')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.row.city)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.row.city.name), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                ], 64))
              : (_ctx.column.key === 'companyName')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (_ctx.row.companyName)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.cut(_ctx.row.companyName, 12)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ], 64))
                : (_ctx.column.key === 'sector')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      (_ctx.row.customer && _ctx.row.customer.sector)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.row.customer.sector.name), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" - ")
                          ], 64))
                    ], 64))
                  : (_ctx.column.key === 'additional')
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 8,
                        class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.hasAdditionalServices))
                      }, null, 2))
                    : (_ctx.column.key === 'period')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          (_ctx.row.period)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.row.period.title), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" - ")
                              ], 64))
                        ], 64))
                      : (_ctx.column.key === 'customer')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            (_ctx.column.additionalKey && _ctx.column.additionalKey === 'contacts')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.row.customer)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.cut(_ctx.row.customer.fullName, 12)), 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.row.customer.phone), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(" - ")
                                      ], 64))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.row.customer)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.cut(_ctx.row.customer.shortAddress, 45)), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(" - ")
                                      ], 64))
                                ], 64))
                          ], 64))
                        : (_ctx.column.key === 'status')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                              (_ctx.row.status)
                                ? (_openBlock(), _createBlock(_component_cargo_status, {
                                    key: 0,
                                    status: _ctx.row.status
                                  }, null, 8, ["status"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.column.key === 'hasPackType')
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 12,
                                class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.hasPackType))
                              }, null, 2))
                            : (_ctx.column.key === 'waitList')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  (_ctx.row.waitList && _ctx.row.waitList.status)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.row.waitList.status.name), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.column.key === 'waitListComment')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (_ctx.row.waitList && _ctx.row.waitList.comment)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.row.waitList.comment), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.isWaitListId)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
                                      (_ctx.row.waitList.state.id === 48)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                                        : (_ctx.row.waitList.state.id === 49)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                                          : _createCommentVNode("", true)
                                    ], 64))
                                  : (_ctx.column.key === 'courier')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                                        (_ctx.row.courier)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_ctx.row.courier.fullName), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(" - ")
                                            ], 64))
                                      ], 64))
                                    : (_ctx.column.key === 'takenAt')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 17 }, [
                                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.takenAt)), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 18 }, [
                                          _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                                        ], 64))
}